<template>
  <div class="discuss_wrap">
    <TopCard ref="TopCardRef"
             text="线上答疑"
             :showBack="true" />
    <div class="subject_card_wrap">
      <div class="card"
           @click="checkBoard(item)"
           :style="{'background':boardBackg[item.board_id]?boardBackg[item.board_id].background:'','box-shadow':board_id==item.board_id?'inset #c9bfbf8c -6rem -6rem 8rem':'','background': board_id==item.board_id?'linear-gradient(90deg, rgba(251, 135, 138, 0.50) 0%, rgba(255, 255, 255, 0.00) 80%), #FFF':'#fff'}"
           v-for="item in boardList"
           :key="item.board_id">
           <div><img :src="boardBackg[item.board_id]?boardBackg[item.board_id].url:''"></div>
        <div class="text">
          {{item.board_name}}
        </div>
         
      </div>
    </div>
    <div class="type_wrap">
      <div class="post_type">
        <div :class="{'item':true,'isActive':item.value == type}"
             @click="checkType(item)"
             v-for="item in discuss_post_type"
             :key="item.value">
          {{item.label}}
        </div>
      </div>
      <div class="search">
        <div class="btn"
             @click="fatie">
               <img src="@/assets/搜索.png"
             alt="">
          发帖
        </div>
                   <div class="btn"
             @click="showDialog">
               <img src="@/assets/发帖.png"
              
             alt="">
          查询
        </div>
      </div>
    </div>
    <div class="list">
      <div class="discuss_item"
           v-for="(item,index) in list"
           @click="toPage(item)"
           :key="index">
           <div class="subject" :style="{'background':boardBackg[item.board_id]?boardBackg[item.board_id].background:''}">
            {{item.board_name}}
          </div>
        <div class="title">
          <div>
            {{item.discuss_title}}
          </div>
           
        </div>
        <div class="content">
          {{item.discuss_content}}
        </div>
        <div class="attr">
          <div class="right">
            {{item.discuss_time}}
          </div>
          <div class="left">
            <div>
              <img src="@/assets/icon-点赞@2x.png"
                   alt="">
              {{item.discuss_upvote_times}}
            </div>
            <div>
              <img src="@/assets/dayi/pl.png"
                   alt="">
              {{item.discuss_re_times}}
            </div>
            <div @click.stop="deleteDiscuss(item)" v-show="type=='1'">
              <img src="@/assets/Trash.png"
                   alt="">
               删除
            </div>
          </div>
           
        </div>
      </div>
    </div>
    <Form ref="FormRef" />
    <Reply ref="ReplyRef" />
  </div>
</template>

<script>
import { getBoard, getBoardList,delChat } from '@/api/discuss.js'
import TopCard from '@/views/components/top_card/index.vue'
import Form from './components/form.vue'
import Reply from './components/reply.vue'

export default {
  data () {
    return {
      type: 0,
      board_id: '',
      keyword: '',
      list: [],
      boardBackg: {
        1: {
        background: '#F67171',
          url: require(`@/assets/discuss/icon-语文@2x.png`)
        },
        2: {
          background: '#FF7745',
          url: require(`@/assets/discuss/icon-数学@2x.png`)
        },
        3: {
          background: '#6C67F9',
          url: require(`@/assets/discuss/icon-英语@2x.png`)
        },
        4: {
          background: '#FFA800',
          url: require(`@/assets/discuss/icon-物理@2x.png`)

        },
        5: {
          background: '#5EE5A0',
          url: require(`@/assets/discuss/icon-化学@2x.png`)

        },
        6: {
          background: '#2DB6FF',
          url: require(`@/assets/discuss/icon-生物@2x.png`)
        },
        // 地理
        7: {
          background: '#2DB6FF',
          url: require(`@/assets/discuss/icon-生物@2x.png`)
        },
        // 历史
        8: {
          background: '#FDB638',
          url: require(`@/assets/discuss/icon-物理@2x.png`)
        },
        // 政治
        9: {
          background: '#5EE5A0',
          url: require(`@/assets/discuss/icon-化学@2x.png`)
        },
        10: {
          background: '#FFD34B',
          url: require(`@/assets/discuss/icon-服务区@2x.png`)
        }
      },
      boardList: [
        { board_name: '语文', board_id: 1 },
        { board_name: '数学', board_id: 2 },
        { board_name: '英语', board_id: 3 },
        { board_name: '物理', board_id: 4 },
        { board_name: '化学', board_id: 5 },
        { board_name: '生物', board_id: 6 },
        { board_name: '服务区', board_id: 11 },
      ],
      discuss_post_type: [
        { label: '全部帖子', value: 0 },
        { label: '我的帖子', value: 1 },
        { label: '我的回帖', value: 2 },
        { label: '我的点赞', value: 3 },
      ]
    }
  },
  components: {
    TopCard, Form, Reply
  },
  mounted () {
    this.initList()
    // this.$nextTick(() => {
    //   this.$refs.FormRef.dialogVisible = true
    // })

  },
  methods: {
    deleteDiscuss (item) {
         this.$confirm("是否删除帖子，删除后不可恢复", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // type: "warning",
        //  customClass: "my-confirm-box"
      }).then(async () => {
        let form = {
         discuss_id: item.discuss_id
        }

        const data = await delChat(form)
        if (data.status == 200) {
          this.$message.success('删除成功')
        
          this.checkBoard()
        }

      })
 
    },
    toPage (item) {
      this.$router.push('/discuss_info?discuss_id=' + item.discuss_id)
    },
    async initList () {
      const { data } = await getBoard()
      // console.log(data)
      this.boardList = data
      console.log('sssssss',JSON.parse(window.localStorage.getItem('board_item')))
      if (JSON.parse(window.localStorage.getItem('board_item'))) {
        this.checkBoard(JSON.parse(window.localStorage.getItem('board_item')))
      } else {
        this.checkBoard(data[0])
      }

    },
    async checkBoard (item = null) {
      window.localStorage.setItem('board_item', JSON.stringify(item))
      if (item) {
        this.board_id = item.board_id
        this.keyword = ''
      }
      let params = {
        discuss_board: this.board_id,
        discuss_post_type: this.type,
        search: this.keyword
      }
      const { data } = await getBoardList(params)
      this.list = data.volist
    },
    checkType (item) {
      this.type = item.value
      this.keyword = ''
      this.checkBoard()
    },
    fatie () {
      let form = {
        board_id: '',
        discuss_title: '',
        discuss_content: '',
        question_id: '',
      }
      this.$refs.FormRef.dialogVisible = true
      this.$refs.FormRef.form = form
      // 这里不知道为什么 dialog的z-index比loading高
      setTimeout(() => {
        document.getElementsByClassName('v-modal')[0].style['z-index'] = 1998
      }, 100);
    },
    showDialog () {
      this.$refs.ReplyRef.keyword = this.keyword
      this.$refs.ReplyRef.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.discuss_wrap {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #E9F1FC;
  .subject_card_wrap {
    display: flex;
    margin-bottom: 20rem;
    overflow-x: auto;
    padding-bottom: 20rem;
    // overflow-x: auto;
    .card {
      flex-shrink: 0;
      width:130rem;
      height: 130rem;
      border-radius: 24rem;
      margin-left: 3%;
      font-size: 24rem;
      font-weight: bold;
      color: #333333;
      position: relative;
      cursor: pointer;
      display: flex;
        justify-content: center;
        align-items: center;
      flex-direction: column;
      .text {
       color: var(--light-666666, #666);
text-align: right;
font-size: 24rem;
font-style: normal;
font-weight: 400;
line-height: 42rem; /* 150% */
      }
      p {
        // margin: 20rem 0 0 20rem;
      }
      img {
        height: 54rem;
        width: 54rem;
        // position: absolute;
        // right: 10%;
        // top: 36rem;
      }
      &:nth-child(1) {
        margin-left: 2.08%;
      }
    }
  }
  .type_wrap {
  display: flex;
width: 1630rem;
height: 48rem;
padding: 19rem 72rem;
align-items: center;
// gap: 517rem;
border-radius: 20rem 20rem 0 0;
margin-left: 80rem;
background: linear-gradient(180deg, #CEEBFF 0%, #93C7FF 121.94%);
    .post_type {
      width: 40%;
      display: flex;
      justify-content: space-between;
      .item {
        width: 100rem;
        // height: 80rem;
        line-height: 38rem;
        font-size: 20rem;
        font-weight: 400;
        color: #666;
        cursor: pointer;
      }
    }
    .search {
      position: absolute;
      right: 105rem;
      gap: 50rem;
      display: flex;
      align-items: center;
      .btn {
       
        display: flex;
width: 125rem;
height: 50rem;
justify-content: center;
align-items: center;
gap: 8rem;
       border-radius: 10rem;
background: var(--2196-f-3, #2196F3);
        font-size: 16rem;
        font-weight: 400;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      img {
        width: 18rem;
        height: 18rem;
        // margin-left: 40rem;
        cursor: pointer;
      }
    }
  }
  .list {
    height: calc(100vh - 330rem);
    overflow-y: auto;
    width: 1840rem;
margin-left:40rem;
   border-radius: 20rem 20rem 0 0;
border-top: 2rem solid #FFF;
border-right: 2rem solid #FFF;
border-left: 2rem solid #FFF;
background: #FBFCFF;
box-shadow: 0 4rem 8rem 0 #B0DCFF;
    .discuss_item {
      height: 184rem;
      margin: 30rem;
      position: relative;
      border-radius: 20rem;
background: #FFF;
box-shadow: 0 4rem 8rem 0 #F1F4FF;
      overflow: hidden;
      cursor: pointer;
       .subject {
        display: flex;
// width: 46rem;
height: 23rem;
padding: 8rem 35rem;
justify-content: center;
align-items: center;
gap: 10rem;
position: absolute;
right: 0rem;
border-radius: 0 20rem;
// background: #F67171;
        color: #FFF;
 
font-size: 24rem;
font-style: normal;
font-weight: 400;
 
        }
      .title {
        display: flex;
        justify-content: space-between;
        margin: 20rem;
        
        div {
          &:nth-child(1) {
            font-size: 24rem;
            font-weight: bold;
            color: #333333;
          }
          &:nth-child(2) {
            // display: flex;
            // justify-content: center;
            // align-items: center;
            // width: 90rem;
            // height: 44rem;
            // background: #ebf3ff;
            // border-radius: 5rem;
            // font-size: 22rem;
            // font-weight: bold;
            // color: #2196f3;
            
          }
        }
      }
      .content {
        font-size: 24rem;
        font-weight: 500;
        color: #333333;
        margin-left: 20rem;
      }
      .attr {
        margin: 20rem;
        display: flex;
        display: flex;
        justify-content: space-between;
        .left {
          color: #999;
          font-size: 24rem;
          font-weight: 400;
          display: flex;
          div {
            display: flex;
            align-items: center;
            &:nth-child(2) {
              margin-left: 30rem;
            }
              &:nth-child(3) {
              margin-left: 30rem;
            }
          }

          img {
            width: 24rem;
            height: 24rem;
            margin-right: 14rem;
          }
        }
        .right {
       color: var(--light-999999, #999);
font-size: 20rem;
font-style: normal;
font-weight: 400;
line-height: 30rem; /* 150% */
        }
      }
    }
  }
  .pagintion {
    height: 50rem;
  }
.isActive {
  color: #2196f3;
  font-weight: bold;
  position: relative; /* 必须加 */
  padding-bottom: 10px; /* 给下划线留出空间 */
}

.isActive::after {
  content: '';
  position: absolute;
  left: 12rem;
  bottom: 0;
  width: 50%;
  border-radius: 8px;
  height: 3px; /* 你要的下划线粗细 */
  background: #2196f3;
}
  /* 整个滚动条 */
  ::-webkit-scrollbar {
    width: 6rem;
    height: 6rem;
  }
  /* 滚动条上的按钮 (上下箭头). */
  ::-webkit-scrollbar-button {
    display: none;
  }
  /* 滚动条上的滚动滑块. */
  ::-webkit-scrollbar-thumb {
    background-color: rgba(202, 202, 210, 0.8);
    border-radius: 50rem;
    cursor: pointer;
  }
  /* 滚动条没有滑块的轨道部分 */
  ::-webkit-scrollbar-track-piece {
    border-radius: 20rem;
  }
  /* 当同时有垂直滚动条和水平滚动条时交汇的部分. */
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
}

::v-deep .el-dialog__wrapper {
  z-index: 1999 !important;
}
 
  ::v-deep .el-message-box{
  border-radius: 32rem;
background: #FFF;
}


// .v-modal {
//   z-index: 1990 !important;
// }
</style>
<!-- 👇 新增这个，专门覆盖 element 弹窗 -->
<style>
.my-confirm-box  {
    border-radius: 32rem;
background: #FFF;
 
width: 480rem;
 
height: 240rem;
}
 
</style>